import { usePageMeta } from '@/hooks/usePageMeta';
import HeroCarousel from './components/HeroCarousel';
import Advantages from './components/Advantages';
import CategoryQuickNav from './components/CategoryQuickNav';
import TopRanking from './components/TopRanking';
import LatestSoftware from './components/LatestSoftware';

export default function Home() {
  usePageMeta(
    '看片软件-高速稳定的影视播放软件下载平台',
    '看片软件提供丰富的影视播放工具推荐与下载，涵盖多款热门看片软件，帮助用户轻松观看电影和电视剧。',
  );

  return (
    <>
      <h1 className="sr-only">看片软件-高速稳定的影视播放软件下载平台</h1>
      <HeroCarousel />
      <Advantages />
      <CategoryQuickNav />

      <section className="mx-auto max-w-[1280px] px-4 pb-6 md:px-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[320px_1fr]">
          <aside className="lg:sticky lg:top-20 lg:self-start">
            <TopRanking />
          </aside>
          <div>
            <LatestSoftware />
          </div>
        </div>
      </section>
    </>
  );
}